/**
 * Update the form's state
 *
 * @param    { SyntheticEvent }    e        event
 * @param    { Object }            value    files data
 * @param    { String }            name     html name
 */
const types = ['image/jpeg', 'image/png', 'image/svg+xml', 'image/gif', 'application/pdf'];
export default function handleFileChange({
  e,
  previews,
  name,
  source
}) {
  const component = this,
    props = this.props,
    state = this.state;

  // Get files to upload (remove previews of files on the server)
  // Files on the server are previews in base64

  const files_descriptor = previews.map(function (preview) {
    let data = {
      status: preview.file instanceof File ? 'new' : 'uploaded',
      title: preview.title || ''
    };
    if (data.status === 'uploaded') {
      if (preview.url) data.url = preview.url;
      if (preview.pdf) data.pdf = preview.pdf;
    } else {
      data.filename = preview.filename;
    }
    return data;
  });
  delete state.status_messages[name];
  files_descriptor.forEach(function (preview, i) {
    if (preview.title) {
      delete state.status_messages[name + '[' + i + '][title]'];
      delete state.status_messages[name + '[title]'];
    }
  });
  component.setState({
    ['__files-' + name]: previews,
    [name]: files_descriptor,
    status_messages: state.status_messages,
    info: undefined,
    error: undefined,
    warning: undefined
  });
}
